import { LoadingButton } from '@mui/lab';
import { Alert, MenuItem, Stack, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';

import FormProvider, { RHFSelect, RHFTextField } from '@/commons/hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { getSettingsTransactionType } from '@/services/settings';
import { useQuery } from '@tanstack/react-query';
import { schemaType, transactionCashRegisterSchema } from './validations';

type Props = {
  isWithdrawal?: boolean;
  isLoading?: boolean;
  onSave: (values: schemaType) => Promise<void>;
};

export default function CashTransactionForm({
  isWithdrawal = false,
  onSave,
  isLoading,
}: Readonly<Props>) {
  const methods = useForm<schemaType>({
    defaultValues: {},
    resolver: yupResolver(transactionCashRegisterSchema),
  });

  const { reset, handleSubmit, control } = methods;
  const { data: transactionType } = useQuery({
    queryKey: ['transaction-type'],
    queryFn: getSettingsTransactionType,
  });

  const onSubmit = async (data: schemaType) => {
    try {
      await onSave({ ...data });
      reset();
    } catch (error) {
      console.log(error);
    }
  };

  const categories = isWithdrawal
    ? transactionType?.types?.withdraws
    : transactionType?.types?.deposits;

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Stack sx={{ px: 3, gap: 2, py: 2 }} style={{ display: 'flex', flexDirection: 'column' }}>
        {categories && !categories?.length && (
          <Alert severity="warning">
          {`  Se deben crear primero categoria de transacciones de tipo ${isWithdrawal ? 'Retiro' : 'Deposito'}.`}
            <br /> <Typography fontWeight="bold">Infoma a tu administrador</Typography>
          </Alert>
        )}
        <RHFTextField
          name="cash"
          label="Valor"
          placeholder="Valor de Transaccion"
          control={control}
        />
      </Stack>

      <Stack sx={{ px: 3, gap: 2, py: 2 }} style={{ display: 'flex', flexDirection: 'column' }}>
        <RHFSelect name="type" label="Categoria de Transaccion">
          {(categories ?? [])?.map((category: any) => (
            <MenuItem key={category} value={category}>
              {category}
            </MenuItem>
          ))}
        </RHFSelect>
      </Stack>

      <Stack sx={{ px: 3, gap: 2 }} style={{ display: 'flex', flexDirection: 'column' }}>
        <RHFTextField
          name="comment"
          label="Comentarios"
          placeholder="Escribe la razon de la transaccion"
          control={control}
        />
      </Stack>

      <Stack sx={{ justifyContent: 'center', my: 2 }}>
        <LoadingButton type="submit" variant="outlined"  disabled={!categories || !categories.length}>
          {isWithdrawal ? 'Crear Retiro' : 'Crear Abono'}
        </LoadingButton>
      </Stack>
    </FormProvider>
  );
}
